<template>
  <div class="login-container">
    <div class="simple-header">
      <div class="logo" @click="goToHome">
        <img src="../assets/images/logo.png" alt="AiBZ Logo">
      </div>
    </div>
    <div class="login-box">
      <div class="title">
        <h1>AiBZ</h1>
      </div>
      <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form">
        <el-form-item prop="email">
          <el-input
            v-model="loginForm.email"
            prefix-icon="el-icon-message"
            placeholder="邮箱"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model="loginForm.password"
            prefix-icon="el-icon-lock"
            type="password"
            placeholder="密码"
            @keyup.enter.native="handleLogin"
            show-password
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button 
            type="primary" 
            class="login-button" 
            :loading="loading" 
            @click="handleLogin"
          >登录</el-button>
        </el-form-item>
        <div class="login-options">
          <span class="register-link" @click="goToRegister">还没有账号？立即注册</span>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { post } from '../utils/fetch';

export default {
  name: 'LoginPage',
  data() {
    const validateEmail = (rule, value, callback) => {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!value) {
        callback(new Error('请输入邮箱'));
      } else if (!emailPattern.test(value)) {
        callback(new Error('请输入有效的邮箱地址'));
      } else {
        callback();
      }
    };
    return {
      loginForm: {
        email: '',
        password: ''
      },
      loginRules: {
        email: [
          { required: true, trigger: 'blur', validator: validateEmail }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度至少6个字符', trigger: 'blur' }
        ]
      },
      loading: false
    };
  },
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate(async valid => {
        if (valid) {
          this.loading = true;
          try {
            const response = await post('/api/user/login', this.loginForm);
            if (response.code === 200) {
              // 保存用户Token和信息
              localStorage.setItem('token', response.token);
              localStorage.setItem('userInfo', JSON.stringify(response.data));
              
              this.$message.success('登录成功');
              
              // 检查是否存在重定向路径
              const redirectPath = localStorage.getItem('redirectPath');
              if (redirectPath) {
                // 如果存在重定向路径，跳转到该路径并清除
                localStorage.removeItem('redirectPath');
                this.navigateTo(redirectPath);
              } else {
                // 否则跳转到首页
                this.navigateTo('/');
              }
            } else {
              this.$message.error(response.message || '登录失败，请重试');
            }
          } catch (error) {
            this.$message.error('登录失败：' + (error.message || '网络错误'));
          } finally {
            this.loading = false;
          }
        }
      });
    },
    
    // 安全的路由导航方法
    navigateTo(path) {
      if (this.$router.currentRoute.path !== path) {
        this.$router.push(path).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            throw err;
          }
        });
      }
    },
    
    // 前往注册页
    goToRegister() {
      this.navigateTo('/register');
    },
    
    // 前往首页
    goToHome() {
      this.navigateTo('/');
    }
  }
};
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: url('../assets/images/img-home-bg.png') no-repeat center center;
  background-size: cover;
  position: relative;
}

.simple-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 70px;
  width: 100%;
  padding: 0 120px;
  box-sizing: border-box;
  background-color: transparent;
  z-index: 1000;
}

.logo {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.logo img {
  height: 60px;
  width: auto;
  object-fit: contain;
  margin-right: 10px;
}

.login-box {
  width: 525px;
  padding: 60px 50px;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 35px;
  box-shadow: 0px 0 64px 0px rgba(0,23,189,0.12);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.title {
  text-align: center;
  margin-bottom: 60px;
}

.title h1 {
  color: #7e57c2;
  font-size: 36px;
  margin: 0;
}

.login-form {
  margin-top: 30px;
}

.login-form .el-form-item {
  margin-bottom: 30px;
}

.login-form .el-input__inner {
  height: 50px;
  border-radius: 25px;
  padding-left: 20px;
}

.login-button {
  width: 100%;
  border-radius: 25px;
  height: 50px;
  font-size: 18px;
  background-color: #7e57c2;
  border-color: #7e57c2;
  margin-top: 20px;
}

.login-button:hover {
  background-color: #6c4aa6;
  border-color: #6c4aa6;
}

.login-options {
  margin-top: 30px;
  text-align: center;
}

.register-link {
  color: #7e57c2;
  cursor: pointer;
  font-size: 16px;
}

.register-link:hover {
  text-decoration: underline;
}

/* 调整图标位置 */
.el-input__prefix {
  left: 15px;
}
</style> 